import { render, staticRenderFns } from "./TransportDetectionReportScreen.vue?vue&type=template&id=2806a3f2"
import script from "./TransportDetectionReportScreen.vue?vue&type=script&lang=js"
export * from "./TransportDetectionReportScreen.vue?vue&type=script&lang=js"
import style0 from "./TransportDetectionReportScreen.vue?vue&type=style&index=0&id=2806a3f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports